import React from "react";

const AnnotationTriangle = () => {
  return (
    <React.Fragment>
      <span className="icon-triangle"></span>
    </React.Fragment>
  );
};

export default AnnotationTriangle;
